import { render, staticRenderFns } from "./ColleagueDetails.vue?vue&type=template&id=0af235dc&scoped=true&"
import script from "./ColleagueDetails.vue?vue&type=script&lang=js&"
export * from "./ColleagueDetails.vue?vue&type=script&lang=js&"
import style0 from "./ColleagueDetails.vue?vue&type=style&index=0&id=0af235dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af235dc",
  null
  
)

export default component.exports